import request from '@/utils/request';
import { exportUrl } from '@/utils/index';

/**
 *  查询教师用户列表
 */
export function getTeacherList(params) {
  return request({
    url: `/funteach/teachers/page`,
    method: 'get',
    params: params
  });
}

// 导出教师记录
export function exportTeacherExcel(options) {
  const url = exportUrl(options, '/funteach/teachers/export');
  return url;
}

/**
 *  查询家长用户列表
 */
export function getParentList(params) {
  return request({
    url: `/funteach/parents/kid/page`,
    method: 'get',
    params: params
  });
}

// 导出家长记录
export function exportParentExcel(options) {
  const url = exportUrl(options, '/funteach/parents/kid/export');
  return url;
}
// ****************************************商品管理**********************************************
/**
 *  查询商品分页列表
 */
export function getPagelist(params) {
  return request({
    url: `/funteach/products/page`,
    method: 'get',
    params: params
  });
}

// 上架商品
export function online(options) {
  return request({
    url: `/funteach/products/online`,
    method: 'put',
    params: options
  });
}

// 下架商品
export function offline(options) {
  return request({
    url: `/funteach/products/offline`,
    method: 'put',
    params: options
  });
}

// 新增商品
export function productsAdd(options) {
  return request({
    url: `/funteach/products`,
    method: 'post',
    data: options
  });
}

// 更新商品
export function productsEdit(options, id) {
  return request({
    url: `/funteach/products?id=${id}`,
    method: 'put',
    data: options
  });
}

// 商品详情
export function productsDetail(options) {
  return request({
    url: `/funteach/products`,
    method: 'get',
    params: options
  });
}

// 获取商品试用期限
export function getTrialPeriod() {
  return request({
    url: `/funteach/product/probations`,
    method: 'get'
  });
}

// 保存商品试用期限
export function saveTrialPeriod(options) {
  return request({
    url: `/funteach/product/probations`,
    method: 'put',
    data: options
  });
}

// ****************************************订单管理**********************************************
// 查询订单分页列表
export function getProductsPagelist(options) {
  return request({
    url: `/funteach/orders/page`,
    method: 'get',
    params: options
  });
}

// 作废订单
export function invalid(options) {
  return request({
    url: `/funteach/orders/invalid`,
    method: 'put',
    params: options
  });
}

// 导出订单列表
export function ordersExport(options) {
  const url = exportUrl(options, '/funteach/orders/export');
  return url;
}

// 更新订单
export function ordersEdit(options, id) {
  return request({
    url: `/funteach/orders?id=${id}`,
    method: 'put',
    data: options
  });
}

// 更新并授权订单
export function ordersAuthorize(options, id) {
  return request({
    url: `/funteach/orders/authorize?id=${id}`,
    method: 'put',
    data: options
  });
}

// 获取订单信息
export function ordersDetail(id) {
  return request({
    url: `/funteach/orders?id=${id}`,
    method: 'get'
  });
}

// ****************************************数据管理**********************************************
// 查询教师使用分页列表
export function getTeacherStatisticslist(options) {
  return request({
    url: `/funteach/teacher/statistics/page`,
    method: 'get',
    params: options
  });
}

// 导出教师使用记录
export function exportTeacherStatisticsExcel(options) {
  const url = exportUrl(options, '/funteach/teacher/statistics/export');
  return url;
}

// 查询教师使用小程序列表
export function getTeacherAppletist(options) {
  return request({
    url: `/funteach/app/statistics/page`,
    method: 'get',
    params: options
  });
}

// 导出教师小程序使用记录
export function exportAppletExcel(options) {
  const url = exportUrl(options, '/funteach/app/statistics/export');
  return url;
}

// ****************************************教师反馈管理**********************************************
// 查询教师反馈分页列表
export function getFeedBacsList(options) {
  return request({
    url: `/funteach/platform/feedbacks/page`,
    method: 'get',
    params: options
  });
}

// 获取互动应用反馈更新处理状态
export function getFeedBacsStatus(id, options) {
  return request({
    url: `/funteach/platform/feedbacks/${id}/handle-status`,
    method: 'put',
    params: options
  });
}

// 获取互动应用反馈更新处理完成状态
export function getFeedBacsFinishedStatus(id) {
  return request({
    url: `/funteach/platform/feedbacks/handle/finished?id=${id}`,
    method: 'put'
  });
}

// 获取互动应用反馈更新处理未完成状态
export function getFeedBacsProcessingStatus(id) {
  return request({
    url: `/funteach/platform/feedbacks/handle/processing?id=${id}`,
    method: 'put'
  });
}

// 获取互动应用反馈列表
export function getFeedBacsExport(options) {
  const url = exportUrl(options, '/funteach/platform/feedbacks/export');
  return url;
}

// 获取科目列表
export function getsubjectList() {
  return request({
    url: `/funteach/dictionaries/subject/list`,
    method: 'get'
  });
}

// 获取教师设置
export function getTeacherSettings(op) {
  return request({
    url: `/funteach/teacher/settings`,
    method: 'get',
    params: op
  });
}

// 保存教师设置
export function saveTeacherSettings(teacherId, op) {
  return request({
    url: `/funteach/teacher/settings?teacherId=${teacherId}`,
    method: 'post',
    data: op
  });
}
